namespace HA.Core.HTML.Navigation {
    //noinspection TsLint
    export class UserItem extends Item {
        /**
         *
         * @param data
         */
        public updateImage(data: Map<any, any>) {
            return this.getImageTag().src = data.get("src");
        }


        public isConnected(): void {
            this.addClass("connected");
            const tag = this.findById(this.getImageId());
            if(tag) {
                tag.addClass("connected");
            }
        }
s
        public disconnected(): void {
            this.removeClass("connected");
            const tag = this.findById(this.getImageId());
            if(tag) {
                tag.removeClass("connected");
            }
        }

        /**
         *
         * @returns {any}
         */
        protected getImageTag() {
            return this.get("image");
        }

        /**
         *
         * @returns {any}
         */
        protected getImageId() {
            return this.get("imageId");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("image", this.findElementById(this.getImageId()));
        }
    }
}
